import PrimaryButton from "components/buttons/primary-button";
import CheckBox from "components/check-box";
import TextArea from "components/inputs/text-area";
import TextInput from "components/inputs/text-input";
import Typography from "components/typography";
import LinkText from "components/typography/linkText";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

const ContactUs = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [accept, setAccept] = useState(false);

  const CanSend = useMemo(() => {
    if (
      fullName.length > 0 &&
      email.length > 0 &&
      message.length > 0 &&
      accept
    ) {
      return true;
    }
    return false;
  }, [fullName, email, message, accept]);

  const SendMessage = async () => {};
  return (
    <Container>
      <Typography
        color={Colors.yellow400}
        align="center"
        weight="semibold"
        size="lg"
        m_size="m"
        mb="1.2"
      >
        Contact Us
      </Typography>
      <Typography
        align="center"
        size="3.6rem"
        mb="2"
        weight="semibold"
        m_size="3rem"
        m_mb="1.6"
      >
        Chat to our friendly team
      </Typography>
      <Typography
        mb="6.4"
        align="center"
        color={Colors.grey400}
        size="2xl"
        m_size="m"
        m_mb="4.8"
      >
        We’d love to hear from you. Please fill out this form or shoot us an
        email.
      </Typography>
      <Body>
        <GridItem>
          <IconContainer>
            <IconBody>
              <Icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6"
                    stroke="#FEB73D"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Icon>
            </IconBody>
          </IconContainer>
          <Typography mb="0.8" size="2xl" weight="semibold" align="center">
            Email
          </Typography>
          <Typography size="lg" mb="2" color={Colors.grey500} align="center">
            Our friendly team is here to help.
          </Typography>
          <Typography
            size="lg"
            weight="semibold"
            align="center"
            color={Colors.yellow400}
          >
            support@ratedafrika.com
          </Typography>
        </GridItem>
        <GridItem>
          <IconContainer>
            <IconBody>
              <Icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5252 14.2869L21.2416 12.9691L19.331 11.9305L18.6146 13.2483ZM20.893 16.3511L19.4723 17.7636L20.5299 18.8273L21.9506 17.4148L20.893 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34423 14.1947L8.28659 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34423 14.1947C5.47285 10.3453 4.83156 7.10767 4.75173 5.70306L3.25415 5.78817C3.35461 7.556 4.14868 11.144 8.28659 15.2584L9.34423 14.1947ZM10.7195 8.01442L11.0063 7.72923L9.94875 6.66557L9.66194 6.95074L10.7195 8.01442ZM11.2346 4.09402L9.9737 2.40962L8.77291 3.30856L10.0338 4.99297L11.2346 4.09402ZM5.73268 2.043L4.16308 3.60369L5.22072 4.66737L6.79032 3.10668L5.73268 2.043ZM10.1907 7.48258C9.66194 6.95075 9.66122 6.95145 9.6605 6.95217C9.66026 6.95241 9.65954 6.95314 9.65905 6.95363C9.65807 6.95462 9.65707 6.95562 9.65606 6.95665C9.65403 6.95872 9.65193 6.96087 9.64977 6.96311C9.64544 6.9676 9.64086 6.97247 9.63604 6.97771C9.62639 6.98817 9.6158 7.00015 9.60446 7.01368C9.58179 7.04073 9.5561 7.07404 9.5291 7.11389C9.47497 7.19378 9.41599 7.29941 9.36594 7.43225C9.26381 7.7033 9.20906 8.06061 9.2777 8.50306C9.41194 9.36834 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.545 10.8231 8.6806 10.7599 8.27311C10.7298 8.07917 10.761 7.98373 10.7696 7.96112C10.7748 7.94714 10.7773 7.94571 10.7709 7.95526C10.7677 7.95993 10.7624 7.96724 10.7541 7.97709C10.75 7.98202 10.7451 7.98761 10.7394 7.99382C10.7365 7.99693 10.7335 8.00021 10.7301 8.00363C10.7285 8.00535 10.7268 8.0071 10.725 8.0089C10.7241 8.0098 10.7232 8.01071 10.7223 8.01163C10.7219 8.01209 10.7212 8.01279 10.7209 8.01302C10.7202 8.01372 10.7195 8.01442 10.1907 7.48258ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.9737 2.40962C8.95439 1.04803 6.95001 0.832585 5.73268 2.043L6.79032 3.10668C7.322 2.57801 8.26628 2.63182 8.77291 3.30856L9.9737 2.40962ZM4.75173 5.70306C4.73206 5.35696 4.8908 4.99541 5.22072 4.66737L4.16308 3.60369C3.62576 4.13796 3.20334 4.89426 3.25415 5.78817L4.75173 5.70306ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72923C11.9908 6.75031 12.064 5.20191 11.2346 4.09402L10.0338 4.99297C10.4373 5.53195 10.3773 6.2394 9.94875 6.66557L11.0063 7.72923ZM20.5252 14.2869C21.343 14.7315 21.4704 15.7769 20.893 16.3511L21.9506 17.4148C23.2908 16.0821 22.8776 13.8584 21.2416 12.9691L20.5252 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z"
                    fill="#FEB73D"
                  />
                </svg>
              </Icon>
            </IconBody>
          </IconContainer>
          <Typography mb="0.8" size="2xl" weight="semibold" align="center">
            Phone
          </Typography>
          <Typography size="lg" mb="2" color={Colors.grey500} align="center">
            Mon-Fri from 8am to 5pm.
          </Typography>
          <Typography
            size="lg"
            weight="semibold"
            align="center"
            color={Colors.yellow400}
          >
            +1 (555) 000-0000
          </Typography>
        </GridItem>

        <Form onSubmit={SendMessage}>
          <TextInput
            required
            placeholder="Enter your full name"
            label="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          <TextInput
            required
            placeholder="example@gmail.com"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextArea
            label="Message"
            required
            height="10rem"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Flex>
            <CheckBox
              onChange={(value) => setAccept(value)}
              defaultState={accept}
            />
            <Typography mr="0.3" ml="0.5" size="lg">
              You accept Rated Afrika’s{" "}
            </Typography>
            <LinkText
              to="/terms"
              text="Terms & Conditions"
              color="white"
              size="lg"
            />
          </Flex>

          <PrimaryButton
            text="Send Message"
            inset
            sparkle
            disabled={!CanSend}
            type="submit"
          />
        </Form>
      </Body>
    </Container>
  );
};

export default ContactUs;

const Container = styled.div`
  padding: 9.6rem 10.4rem;
  @media only screen and (max-width: 769px) {
    padding: 4.8rem 2rem;
  }
`;

const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6.4rem;
  @media only screen and (max-width: 769px) {
    gap: 4rem;
    grid-template-columns: 100%;
  }
`;

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  margin-bottom: 2rem;
  background-color: ${Colors.grey900};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconBody = styled.div`
  width: 3.6rem;
  height: 3.6rem;
  background-color: ${Colors.grey700};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Icon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;
